import { Component } from '@angular/core';
import { FooterComponent } from '@coreui/angular';

// Extends CoreUI's FooterComponent so <app-default-footer> renders as a
// c-footer host — mirrors the Carwins admin layout.
@Component({
    selector: 'app-default-footer',
    templateUrl: './default-footer.component.html',
    standalone: false
})
export class DefaultFooterComponent extends FooterComponent {
  constructor() {
    super();
  }
}
